import PropTypes from 'prop-types';
import React, {Component} from 'react';

import ScrollHandler from '../ScrollHandler/ScrollHandler';

class Unveil extends Component {
    static propTypes = {
        /** Flag to determine if the component is unveiled. Useful if using Unveil with Redux */
        unveiled: PropTypes.bool,
        /** Function to call if the component is in view.  Defaults to internal code, managing state internally */
        onUnveil: PropTypes.func,
        /** If using this component for a background image, this is the URL to that image */
        backgroundImage: PropTypes.string,
        /** How many pixels from window bounds should this Lazy Loader unveil itself */
        threshold: PropTypes.number,
        /** Throttle setting in millisconds */
        throttleAmount: PropTypes.number,
        /** Boolean to use window as scroll parent */
        useWindowAsScrollParent: PropTypes.bool,
    };

    static defaultProps = {
        unveiled: false,
        backgroundImage: ''
    };

    constructor(props) {
        super(props);

        this.handleLazyLoad = this.handleLazyLoad.bind(this);

        this.state = {
            showChildren: props.unveiled,
            // this is a base64 encoded transparent 1px gif
            divStyle: {
                backgroundImage: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.unveiled && nextProps.unveiled) {
            this.setUnveilState();
        }
    }

    handleLazyLoad(inView) {
        if (inView) {
            if (this.props.onUnveil) {
                this.props.onUnveil();
            } else {
                this.setUnveilState();
            }
        }
    }

    setUnveilState() {
        let newState = {
            showChildren: true
        };
        let backgroundState;

        if (this.props.backgroundImage !== '') {
            backgroundState = {
                divStyle: {
                    backgroundImage: `url("${this.props.backgroundImage}")`
                }
            };
        }

        this.setState(Object.assign(newState, backgroundState));
    }

    render() {
        const {children, unveiled, onUnveil, backgroundImage, throttleAmount, useWindowAsScrollParent, ...rest} = this.props; // eslint-disable-line no-unused-vars
        const {divStyle, showChildren} = this.state;

        // When the unveil state is handled by an outside piece, such as redux, it was tricky to remove the event listeners in ScrollHandler
        // ScrollHandler does remove the listeners on unmount so instead just do not render a ScrollHandler if the component is visible
        return showChildren ? (
            <div style={divStyle} {...rest}>
                {children}
            </div>
        ) : (
            <ScrollHandler
                onLazyLoad={this.handleLazyLoad}
                style={divStyle}
                throttleAmount={throttleAmount}
                useWindowAsScrollParent={useWindowAsScrollParent}
                {...rest}
            />
        );
    }
}

export default Unveil;
